import { apiGet } from '@/services/apiClient';
import type { ArpSignalRow, CertainSignalRow, RegistrationLogRow } from '../types';

/**
 * The configured `VITE_API_BASE_URL` ends in `/api/attendeeregistrationprocessing`,
 * which an upstream gateway strips before forwarding to the .NET app. The
 * `RegistrationController` itself is declared as `[Route("api/[controller]")]`,
 * so paths here must be prefixed with `api/Registration/...`. The legacy
 * Blazor client also sends `api-version=1`, which these helpers preserve.
 */
const CONTROLLER = 'api/Registration';
const API_VERSION = '1';

/**
 * Mirrors `RegistrationLogModel.GetAllRegistrations`:
 *   GET <base>/api/Registration/GetRegistrationsBySearch?registrationCode=&searchParam=&api-version=1
 */
export async function fetchRegistrationLog(params: {
  registrationCode?: string;
  searchParam?: string;
}): Promise<RegistrationLogRow[]> {
  const qs = new URLSearchParams({
    registrationCode: params.registrationCode ?? '',
    searchParam: params.searchParam ?? '',
    'api-version': API_VERSION,
  });
  return apiGet<RegistrationLogRow[]>(`${CONTROLLER}/GetRegistrationsBySearch?${qs}`);
}

/**
 * Mirrors `RegistrationLogModel.GetCertainSignals`:
 *   GET <base>/api/Registration/GetAllCertainLog?registrationCode=&api-version=1
 */
export async function fetchCertainSignals(registrationCode: string): Promise<CertainSignalRow[]> {
  const qs = new URLSearchParams({ registrationCode });
  qs.set('api-version', API_VERSION);
  return apiGet<CertainSignalRow[]>(`${CONTROLLER}/GetAllCertainLog?${qs}`);
}

/**
 * Mirrors `RegistrationLogModel.GetARPSignals`:
 *   GET <base>/api/Registration/GetAllARPLog?registrationCode=&api-version=1
 */
export async function fetchArpSignals(registrationCode: string): Promise<ArpSignalRow[]> {
  const qs = new URLSearchParams({ registrationCode });
  qs.set('api-version', API_VERSION);
  return apiGet<ArpSignalRow[]>(`${CONTROLLER}/GetAllARPLog?${qs}`);
}
